import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { formatApiError } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function LoginPage({ onSwitchToRegister, onSwitchToForgot }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      if (err.response?.data?.detail) {
        setError(formatApiError(err.response.data.detail));
      } else if (err.message) {
        setError(err.message === 'Network Error' ? 'Network error. Check your connection.' : err.message);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-sm animate-fade-in">
        <div className="mb-8">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground mb-2">TU Ilmenau</p>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tighter leading-none font-['Outfit']">
            Timetable
          </h1>
          <p className="text-sm text-muted-foreground mt-3">Sign in to view your schedule</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="bg-destructive/10 text-destructive text-sm p-3 rounded-sm border border-destructive/20" data-testid="login-error">
              {error}
            </div>
          )}
          <div className="space-y-2">
            <Label htmlFor="login-email" className="text-xs font-bold uppercase tracking-[0.15em]">Email</Label>
            <Input id="login-email" name="email" autoComplete="username" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" required className="rounded-sm h-11 border bg-background" />
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <Label htmlFor="login-password" className="text-xs font-bold uppercase tracking-[0.15em]">Password</Label>
              <button type="button" onClick={onSwitchToForgot} className="text-xs text-primary font-semibold hover:underline">Forgot?</button>
            </div>
            <Input id="login-password" name="password" autoComplete="current-password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" required className="rounded-sm h-11 border bg-background" />
          </div>
          <Button type="submit" data-testid="login-submit-button" disabled={loading} className="w-full h-11 rounded-sm font-semibold text-sm tracking-wide">
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          No account?{' '}
          <button onClick={onSwitchToRegister} data-testid="switch-to-register" className="text-primary font-semibold hover:underline underline-offset-4 transition-colors duration-150">
            Create one
          </button>
        </p>
      </div>
    </div>
  );
}
